import http from '~/http/cryptomat';

export default ({
  state: {
    data: [],
    filters: {},
    page: 1,
    pages: 0,
    limit: 10,
    itemsPerPage: 0,
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_ORDERS_LIST(state, data) { state.data = data; },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        filters,
        page,
      } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const formattedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value || value === 0) {
          acc[key] = value;
        }
        return acc;
      }, {});
      return {
        ...formattedFilters,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadOrders({ getters, commit }) {
      const response = await http.post('/api/Orders', {
        ...getters.requestData,
      });
      const { Orders, pages } = response.data;
      commit('SET_ORDERS_LIST', Orders);
      if (pages) {
        commit('SET_PAGES', pages);
      }
    },

    async rejectOrder(__store, data) {
      const response = await http.post('/api/Orders/Reject', {
        orderId: data.orderId,
        reason: data.reason,
      });
      return response;
    },

    async confirmOrder(__store, data) {
      const response = await http.post('/api/Orders/Confirm', {
        orderId: data.orderId,
        reason: data.reason,
      });
      return response;
    },
  },

  namespaced: true,
});
